.DiceCube {
  width: 1em;
  height: 1em;
  perspective: 200em;
}
.DiceCube .Cube {
  width: 1em;
  height: 1em;
  position: absolute;
  transform-style: preserve-3d;
  transform: rotate3d(0, 0, 0, 90deg) rotate3d(0, 0, 1, -90deg);
  transition-duration: 1s;
  transition-property: transform;
  transition-timing-function: ease-out;
}
.DiceCube .Cube[animation=spin] {
  animation-name: spin3d;
  animation-duration: 10s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.DiceCube .Cube[animation=roll] {
  animation-duration: 0.75s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;
}
.DiceCube .Cube[animation=roll][faceIndex="0"] {
  animation-name: roll-to-0;
}
.DiceCube .Cube[animation=roll][faceIndex="1"] {
  animation-name: roll-to-1;
}
.DiceCube .Cube[animation=roll][faceIndex="2"] {
  animation-name: roll-to-2;
}
.DiceCube .Cube[animation=roll][faceIndex="3"] {
  animation-name: roll-to-3;
}
.DiceCube .Cube[animation=roll][faceIndex="4"] {
  animation-name: roll-to-4;
}
.DiceCube .Cube[animation=roll][faceIndex="5"] {
  animation-name: roll-to-5;
}
.DiceCube .Cube[animation=bounce] {
  animation-duration: 0.75s;
  animation-fill-mode: forwards;
  animation-name: bounce;
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.DiceCube .Cube[animation=none][faceIndex="0"] .DiceFace:not([index="0"]),
.DiceCube .Cube[animation=none][faceIndex="0"] .InternalFace:not([index="0"]) {
  opacity: 0;
}
.DiceCube .Cube[animation=none][faceIndex="1"] .DiceFace:not([index="1"]),
.DiceCube .Cube[animation=none][faceIndex="1"] .InternalFace:not([index="1"]) {
  opacity: 0;
}
.DiceCube .Cube[animation=none][faceIndex="2"] .DiceFace:not([index="2"]),
.DiceCube .Cube[animation=none][faceIndex="2"] .InternalFace:not([index="2"]) {
  opacity: 0;
}
.DiceCube .Cube[animation=none][faceIndex="3"] .DiceFace:not([index="3"]),
.DiceCube .Cube[animation=none][faceIndex="3"] .InternalFace:not([index="3"]) {
  opacity: 0;
}
.DiceCube .Cube[animation=none][faceIndex="4"] .DiceFace:not([index="4"]),
.DiceCube .Cube[animation=none][faceIndex="4"] .InternalFace:not([index="4"]) {
  opacity: 0;
}
.DiceCube .Cube[animation=none][faceIndex="5"] .DiceFace:not([index="5"]),
.DiceCube .Cube[animation=none][faceIndex="5"] .InternalFace:not([index="5"]) {
  opacity: 0;
}
.DiceCube .Cube[faceIndex="0"] {
  transform: rotate3d(0, 0, 0, 90deg) rotate3d(0, 0, 1, -90deg);
}
.DiceCube .Cube[faceIndex="1"] {
  transform: rotate3d(0, 1, 0, 180deg) rotate3d(0, 0, 1, 180deg);
}
.DiceCube .Cube[faceIndex="2"] {
  transform: rotate3d(0, 1, 0, 90deg);
}
.DiceCube .Cube[faceIndex="3"] {
  transform: rotate3d(0, 1, 0, -90deg) rotate3d(1, 0, 0, 90deg);
}
.DiceCube .Cube[faceIndex="4"] {
  transform: rotate3d(1, 0, 0, -90deg) rotate3d(0, 1, 0, -90deg);
}
.DiceCube .Cube[faceIndex="5"] {
  transform: rotate3d(1, 0, 0, 90deg) rotate3d(0, 1, 0, 180deg);
}
.DiceCube .Cube .DiceFace {
  position: absolute;
}
.DiceCube .Cube .DiceFace[index="0"] {
  transform: translateZ(0.5em) rotateZ(90deg);
}
.DiceCube .Cube .DiceFace[index="1"] {
  transform: translateZ(-0.5em) rotateY(180deg) rotateZ(180deg);
}
.DiceCube .Cube .DiceFace[index="2"] {
  transform: translateX(-0.5em) rotateY(-90deg);
}
.DiceCube .Cube .DiceFace[index="3"] {
  transform: translateX(0.5em) rotateY(90deg) rotateZ(-90deg);
}
.DiceCube .Cube .DiceFace[index="4"] {
  transform: translateY(-0.5em) rotateX(90deg) rotateZ(-90deg);
}
.DiceCube .Cube .DiceFace[index="5"] {
  transform: translateY(0.5em) rotateX(-90deg) rotateZ(180deg);
}
.DiceCube .Cube .InternalFace {
  width: 1em;
  height: 1em;
  position: absolute;
  border-radius: 11%;
  transform-origin: center;
  background-color: #111111;
}
.DiceCube .Cube .InternalFace[index="0"] {
  transform: translateZ(0.45em);
}
.DiceCube .Cube .InternalFace[index="1"] {
  transform: translateZ(-0.45em) rotateY(180deg);
}
.DiceCube .Cube .InternalFace[index="2"] {
  transform: translateX(-0.45em) rotateY(-90deg);
}
.DiceCube .Cube .InternalFace[index="3"] {
  transform: translateX(0.45em) rotateY(90deg);
}
.DiceCube .Cube .InternalFace[index="5"] {
  transform: translateY(0.45em) rotateX(-90deg);
}
.DiceCube .Cube .InternalFace[index="4"] {
  transform: translateY(-0.45em) rotateX(90deg);
}
@keyframes roll-to-0 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 360deg) rotate3d(1, 0, 0, 720deg) rotate3d(0, 0, 1, 990deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes roll-to-1 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 540deg) rotate3d(1, 0, 0, 720deg) rotate3d(0, 0, 1, 1260deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes roll-to-2 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 450deg) rotate3d(1, 0, 0, 720deg) rotate3d(0, 0, 1, 1080deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes roll-to-3 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(0, 1, 0, 270deg) rotate3d(1, 0, 0, 810deg) rotate3d(0, 0, 1, 1080deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes roll-to-4 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(1, 0, 0, 630deg) rotate3d(0, 1, 0, 270deg) rotate3d(0, 0, 1, 1080deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes roll-to-5 {
  0% {
    transform: rotate3d(1, 1, 0, 45deg);
  }
  100% {
    transform: rotate3d(1, 0, 0, 810deg) rotate3d(0, 1, 0, 540deg) rotate3d(0, 0, 1, 1080deg);
  }
  0%,
  26%,
  50%,
  70%,
  90%,
  100% {
    margin-top: 0em;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  14%,
  16% {
    margin-top: -0.5em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  40% {
    margin-top: -0.25em;
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
  }
  60% {
    margin-top: -0.1em;
  }
  80% {
    margin-top: -0.01em;
  }
}
@keyframes bounce {
  0%,
  20%,
  53%,
  80%,
  100% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0em;
  }
  40%,
  43% {
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    margin-top: -0.5em;
  }
  70% {
    transition-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    margin-top: -0.25em;
  }
  90% {
    margin-top: -0.1em;
  }
  95% {
    margin-top: -0.01em;
  }
}
@keyframes spin3d {
  from {
    transform: rotate3d(0, 0, 0, 0);
  }
  to {
    transform: rotate3d(1, 1, 0, 360deg);
  }
}
